import { CrewChange } from '../../types';

export interface HistoryEvent {
  id: string;
  employeeId: string;
  employeeName: string;
  eventType: 'sign-on' | 'sign-off' | 'continue' | 'vacation-start' | 'vacation-end';
  vesselId?: string;
  vesselName?: string;
  eventDate: string;
  location?: string;
  notes?: string;
  createdAt: string;
}

export interface EmployeeSummary {
  employeeId: string;
  employeeName: string;
  rank: string;
  totalSignOns: number;
  totalSignOffs: number;
  totalVacations: number;
  currentStatus: 'on-vessel' | 'on-vacation' | 'off-duty';
  currentVessel?: string;
  lastActivity: string;
}

export const statusToEventType = (status: CrewChange['status']): HistoryEvent['eventType'] => {
  switch (status) {
    case 'sign_on': return 'sign-on';
    case 'sign_off': return 'sign-off';
    // A continue means the member stayed aboard through the change — it
    // is NOT a new sign-on (they never disembarked).
    case 'continue': return 'continue';
    default: return 'sign-on';
  }
};
